import React from "react";
import { motion } from "framer-motion";

const ReadyToTransform = ({
  title = "Ready to Understand Your Team?",
  description = "Join hundreds of teams using TeamGrid to make smarter decisions and build better workplaces.",
  primaryButtonText = "Register",
  // primaryButtonText = "Start Free Trial",
  primaryButtonLink = "/register",
  secondaryButtonText = "Talk to Sales",
  secondaryButtonLink = "/contact-us",
  showAdditionalInfo = true,
  delay = 1.2,
}) => {
  return (
    <section
      className="ready-cta-section mb-[-1px] relative left-1/2 -ml-[50vw] -mr-[50vw] w-screen max-w-none overflow-hidden text-center"
      style={{
        background: "#000000",
        border: "1px solid rgba(0, 209, 193, 0.15)",
        boxSizing: "border-box",
      }}
    >
      {/* Gradient overlay per spec */}
      <div
        className="absolute inset-0 pointer-events-none"
        style={{
          background: "radial-gradient(74.41% 206.34% at 30% 30%, rgba(0, 217, 217, 0.1) 0%, rgba(0, 217, 217, 0) 50%)",
        }}
      />
      <div className="relative z-10 max-w-4xl mx-auto px-4 sm:px-6 md:px-8 lg:px-12 py-12 md:py-16">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay }}
          className="flex flex-col items-center gap-5"
        >
          <h3 className="!text-white mb-0 max-w-[742px] text-[24px] sm:text-[28px] md:text-[32px] lg:text-[36px] font-bold">
            {title}
          </h3>
          <p
            className="mb-0 max-w-[560px]"
            style={{
              fontFamily: "Inter, sans-serif",
              fontWeight: 400,
              fontSize: "20px",
              lineHeight: "30px",
              color: "#A0A0A0",
            }}
          >
            {description}
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <motion.a
              href={primaryButtonLink}
              className="rounded-[10px] font-bold hover:bg-[#00B5A6] transition-all duration-300"
              style={{
                background: "#00D1C1",
                color: "#000000",
                padding: "17px 32px",
                fontSize: 15,
                lineHeight: "24px",
              }}
              whileHover={{ scale: 1.02 }}
              whileTap={{ scale: 0.98 }}
            >
              {primaryButtonText}
            </motion.a>
            <motion.a
              href={secondaryButtonLink}
              className="border border-white text-white/80 px-8 py-4 rounded-lg font-semibold text-lg hover:bg-white/10 transition-all duration-300"
              whileHover={{ scale: 1.02 }}
              whileTap={{ scale: 0.98 }}
            >
              {secondaryButtonText}
            </motion.a>
          </div>
          {showAdditionalInfo && (
            <p
              className="mb-0"
              style={{
                fontFamily: "Inter, sans-serif",
                fontWeight: 500,
                fontSize: 14,
                lineHeight: "22px",
                color: "#A0A0A0",
              }}
            >
              No credit card required • Full feature access • 5-minute setup
            </p>
          )}
        </motion.div>
      </div>
    </section>
  );
};

export default ReadyToTransform;
